import { useParams, useLocation, Link } from 'react-router-dom'
import { ArrowLeft, Building2, Layers, MapPin } from 'lucide-react'
import BSDCard from '../BSDCard'
import DistrictMap from '../DistrictMap'
import { RSA_LIST } from '../../data/rsa'
import { AMBITI_STATS } from '../../data/ambitiStats'
import { RsaDetailContent } from '../StrutturaDetailDialog'

export default function RsaDetailPage() {
  const { slug } = useParams<{ slug: string }>()
  const location = useLocation()
  const state = location.state as { from?: string } | null
  const backTo = state?.from || '/rsa'

  const rsa = slug ? RSA_LIST.find(r => r.id === slug) : undefined

  if (!rsa) {
    return (
      <div className="cdc-detail-page">
        <div className="cdc-detail-container">
          <Link to={backTo} className="cdc-detail-back"><ArrowLeft size={16} /> Torna</Link>
          <h1>RSA non trovata</h1>
        </div>
      </div>
    )
  }

  return (
    <div className="cdc-detail-page">
      <div className="cdc-detail-container">
        <Link to={backTo} className="cdc-detail-back"><ArrowLeft size={16} /> Torna</Link>

        <BSDCard kind="custom" className="cdc-detail-info-card" sezione="Residenze Sanitarie Assistenziali" style={{ padding: 20 }}>
          <RsaDetailContent rsa={rsa} detailUrl={`/rsa/${slug}`} />
        </BSDCard>

        <BSDCard kind="custom" className="cdc-detail-map-card" sezione="Residenze Sanitarie Assistenziali">
          <h2 className="cdc-detail-section-title"><MapPin size={16} /> Mappa del distretto</h2>
          <DistrictMap
            onSelectDistrict={() => {}}
            onClearSelection={() => {}}
            selectedDistrictId={rsa.ambitoId}
            allowDistrictSelection={false}
            showLegend={false}
            showInstructionText={false}
          />
        </BSDCard>
      </div>
    </div>
  )
}
